import { render, staticRenderFns } from "./OnboardingLoading.vue?vue&type=template&id=be40c0ae&scoped=true"
import script from "./OnboardingLoading.vue?vue&type=script&lang=js"
export * from "./OnboardingLoading.vue?vue&type=script&lang=js"
import style0 from "./OnboardingLoading.vue?vue&type=style&index=0&id=be40c0ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be40c0ae",
  null
  
)

export default component.exports